import type { ReapproAlgorithm, ReaproPeriode } from '@gozoki/api-types'
import { useForm } from 'react-hook-form'

export interface ReaproCategoryStoreParams {
  algorithm: ReapproAlgorithm
  periode: ReaproPeriode
  coefSecu: number
  coefWeekend: number
}

export const DEFAULT_REAPPRO_STORE_CATEGORY_PARAMS: ReaproCategoryStoreParams = {
  algorithm: 'VMAX',
  periode: '5J',
  coefSecu: 1.0,
  coefWeekend: 1.0,
}

export interface ReapproAlgorithmsFormValues {
  params: Record<string, ReaproCategoryStoreParams>
}

export const useReapproAlgorithmMatrixForm = () =>
  useForm<ReapproAlgorithmsFormValues>({
    defaultValues: { params: {} },
  })
